import { AppRouteProps } from "@bsm/component";
import React from "react";

const DevicesUserDetailsContainer = React.lazy(() => import('./containers/DevicesUserDetailsContainer'))
export const DevicesUserDetailsRoutes: Array<AppRouteProps> = [
    {
        path: 'devices',
        title: '{{UserNameDetailsTab}}',
        element: <DevicesUserDetailsContainer />
    }
]